import InformationHeader from "../InformationHeader";
import Metrics from "../Metrics";

const DashboardContainer = () => {
  return (
    <div className="flex flex-col gap-2">
      <InformationHeader />
      <Metrics />
    </div>
  );
};

export default DashboardContainer;
